import React, {useContext, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../../styles/root/home.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import Login from "../root/Login";
import NavBar from "../components/NavBar";

export default function Ecoambit() {
    const {isLoggedIn, userId, user} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();
    const [dades, setDades] = (useState<string>())

    if (isLoggedIn) {
        return (
            <>
                <NavBar/>
                <div className="container-fluid">
                    <div className="row justify-content-center p-4">
                        <div className="col-8 ">
                            <h3 className="titleTop container">MENU INICIAL</h3>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row justify-content-center p-2">
                        <div className="col-8 text-center">

                        </div>
                    </div>
                </div>

            </>
        );
    } else {
        return (
            <Login/>
        );
    }
}
